export const STRIPE_PUBLISHABLE_KEYS = {
  DEV: 'pk_test_51PBQ0g2NghisIiv87iHjaXHl4NkFQAQDsuZIRrgnsoF2R9yTYLkXCWT5EmoAtl0Lu5ji8qQttyRfAigT2bdUWs1Z00plXmMnND',
  LIVE: 'pk_live_51PBQ0g2NghisIiv8owvfeNAdurC3ZVEcdWdAwh4n0PLXIQYFXu9bTU6NT6VCQ0APY2zHJ2cL11gnr42vPBBwn6Qh00tEQpNb15',
}

export const PORTAL_PAYMENT_FEE = 0.03 // 3%;

export const STRIPE_PAYMENT_METHODS = {
  CARD: 'card',
  ACH: 'us_bank_account',
}
